// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable {
    max-height: 200px;  /* Adjust this value based on your preference */
    overflow-y: auto;   /* Enables vertical scrollbar if needed */
    padding: 0 40px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/views/Survey1/poll/game21.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB,GAAG,+CAA+C;IACnE,gBAAgB,IAAI,yCAAyC;IAC7D,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".scrollable {\n    max-height: 200px;  /* Adjust this value based on your preference */\n    overflow-y: auto;   /* Enables vertical scrollbar if needed */\n    padding: 0 40px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
